import type { PropsWithChildren } from 'react'
import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { formToObject } from 'lib/forms/formToObject'
import FlightsDatesModalFooter from '../FlightsDatePicker/FlightsDatesModalFooter'

interface Props {
  title: string
  showDates?: boolean
  showTravellers?: boolean
}

function FlightSearchMenuMobile(props: PropsWithChildren<Props>) {
  const {
    title,
    children,
    showDates,
    showTravellers,
  } = props

  const intl = useIntl()
  const { resolve } = useModalElementContext<any>()
  const { occupants } = useContext(FlightSearchWidgetStateContext)
  const travellerLabel = useMemo(() => formatOccupantsShort(occupants), [occupants])

  const continueText = intl.formatMessage({
    id: 'TNIFgxH6QvWO2MwOnp73',
    defaultMessage: 'Continue',
    description: 'Button text to continue in flight search mobile menu',
  })

  return (
    <ModalBase mode="drawer">
      <form onSubmit={e => {
        e.preventDefault()
        const values = formToObject(e.currentTarget)
        resolve(values)
      }}
      >
        <ModalHeader title={title} />
        <ModalBody>
          <ModalContent>
            {children}
          </ModalContent>
        </ModalBody>
        <ModalFooter
          primaryActionProps={{
            children: continueText,
            type: 'submit',
          }}
        >
          {showDates && <FlightsDatesModalFooter />}
          {showTravellers && travellerLabel && (
            <BodyText variant="medium" weight="bold" align="center">
              {travellerLabel}
            </BodyText>
          )}
        </ModalFooter>
      </form>
    </ModalBase>
  )
}

export default FlightSearchMenuMobile
